<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-buffer"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mb-5">
        <v-col class="text-right" cols="12">
          <v-btn
              color="primary"
              @click="addFieldProject"
          >
            Thêm
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center" class="mt-n6 " justify="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="fields"
              :items-per-page="10"
              class="elevation-1">
            <template v-slot:item.photo_url="{ item }"  >
              <img width="100" :src="url + item.photo_url ? url+item.photo_url : require('@/assets/images/logo_Eglife1.png')" class="pt-2">
            </template>
            <template v-slot:item.description="{ item }"  >
              <span v-html="item.description" class="description"></span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" small @click="editItem(item.id)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)"> mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  DELETE_FIELD_PROJECT,
  GET_LIST_FIELD_PROJECT
} from "@/store/modules/field_project";

export default {
  name: "Field_project",
  data() {
    return {
      page: "Danh sách loại project",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách loại project",
          disabled: false,
        },
      ],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id',
        },
        {text: 'Name', value: 'name'},
        {text: 'Position', value: 'order'},
        {text: 'Description', value: 'description'},
        {text: 'Photo', value: 'photo_url', sortable: false},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      url:''
    }
  },
  computed: {
    ...mapGetters({
      fields: "fields",
    }),
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    await this.$store.dispatch(GET_LIST_FIELD_PROJECT);
  },
  methods: {
    addFieldProject() {
      this.$router.push('/project_management/field_project/add_fieldProject')
    },
    deleteItem(id)
    {
      confirm('Bạn có chắc chắn muốn xóa không ?') &&
      this.$store.dispatch(`${DELETE_FIELD_PROJECT}`,id).then(data=>{
        if(data && data.status === 1) {
          this.$store.dispatch(GET_LIST_FIELD_PROJECT);
        }
      })
    },
    editItem(id) {
      this.$router.push({
        path: "/project_management/field_project/edit_fieldProject/" + id,
      });
    },

  }
}
</script>

<style scoped>
.description{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  max-width: 450px;
}
</style>